export const medicareData = {
  en: {
    metaTitle: 'SingleCare & Medicare | SingleCare',
    metaDescription:
      'Your prescriptions may cost less with SingleCare than with Medicare. Find out when to use SingleCare instead of Medicare and maximize your Rx savings.',
    ogTitle: 'SingleCare & Medicare',
    ogDescription:
      'Your prescriptions may be cheaper with SingleCare than with Medicare. Find out when (and how) to use SingleCare instead of Medicare to maximize your savings.',
    mainHeading: 'Medicare is complicated. SingleCare is easy.',
    medicareTopDrugsHeading: 'Best prices available:',
    medicareTopDrugs: [
      {
        name: 'Amlodipine Besylate',
        seoName: 'amlodipine-besylate'
      },
      {
        name: 'Benzonatate',
        seoName: 'benzonatate'
      },
      {
        name: 'Cyclobenzaprine Hcl',
        seoName: 'cyclobenzaprine-hcl'
      },
      {
        name: 'Albuterol Sulfate Hfa',
        seoName: 'albuterol-sulfate-hfa'
      },
      {
        name: 'Cyanocobalamin',
        seoName: 'cyanocobalamin'
      },
      {
        name: 'Lisinopril',
        seoName: 'lisinopril'
      },
      {
        name: 'Hydrochlorothiazide',
        seoName: 'hydrochlorothiazide'
      },
      {
        name: 'Metoprolol Succinate Er',
        seoName: 'metoprolol-succinate-er'
      }
    ],
    relatedConditions: [
      {
        title: 'Blood Pressure',
        slug: 'blood-pressure-treatment-and-medications'
      },
      {
        title: 'high cholesterol',
        slug: 'high-cholesterol-treatment-and-medications'
      },
      {
        title: 'Arthritis',
        slug: 'arthritis-treatment-and-medications'
      },
      {
        title: 'Diabetes',
        slug: 'diabetes-treatment-and-medications'
      },
      {
        title: 'Congestive Heart Failure',
        slug: 'congestive-heart-failure-treatment-and-medications'
      },
      {
        title: 'Depression',
        slug: 'depression-treatment-and-medications'
      },
      {
        title: 'COPD',
        slug: 'copd-treatment-and-medications'
      },
      {
        title: 'Alzheimer’s',
        slug: 'alzheimers-treatment-and-medications'
      },
      {
        title: 'Atrial Fibrillation ',
        slug: 'atrial-fibrillation-treatment-and-medications'
      }
    ],
    medicareFaqs: [
      {
        Question: 'Why should I check SingleCare if I have Medicare?',
        Answer: [
          'Even with Medicare Advantage or Medicare Part D, Medicare drug prices may still be expensive if you don’t qualify for low income subsidies like Extra Help. On some prescription drugs, you can actually save more by using a free SingleCare prescription discount card instead of Medicare.'
        ]
      },
      {
        Question: 'Can you use SingleCare with Medicare?',
        Answer: [
          'Anyone can use SingleCare’s free drug coupons, even if you receive drug coverage through Medicare Advantage or Medicare Part D. Ask a pharmacist to compare what you would pay under SingleCare vs. Medicare to see if you can save on your medications. Please note, however, that SingleCare and Medicare cannot be used together—you have to use one or the other.'
        ]
      },
      {
        Question: 'When should I use SingleCare instead of Medicare?',
        Answer: [
          "<p>SingleCare can help Medicare consumers save on prescriptions when:</p><ul><li>You don’t have drug coverage through Medicare Advantage or Medicare Part D</li><li>SingleCare prices are lower than your Medicare copay or coinsurance (compare prices on singlecare.com or our app before you go to the pharmacy)</li><li>Your medication isn’t covered by your Medicare Part D plan</li><li>You’re in the Medicare donut hole (also known as the coverage gap)</li></ul><p class='lastPara'>Note: If you use a discount card like SingleCare instead of Medicare, your out-of-pocket costs will not apply to your Medicare deductible.</p>"
        ]
      },
      {
        Question: 'Why isn’t Medicare always the cheapest option?',
        Answer: [
          'Medicare Advantage and Part D have different tiers of coverage. Tier 1 drugs usually have the lowest copay. The higher the tier, the more you’ll usually pay out of pocket. So even if your drug is covered by your Medicare plan, your SingleCare discount may be greater than your Medicare discount, unless you qualify for Medicare Part D’s low income subsidy called Extra Help.'
        ]
      },
      {
        Question: 'Which Medicare parts cover prescriptions?',
        Answer: [
          'Medicare Part D covers prescriptions. If you have Medicare Part A or Part B, you can enroll in separate Medicare drug coverage through Medicare Part D. Medicare Advantage (also called Part C) can bundle Medicare Part A, B, and D. Consumers are not always automatically enrolled in prescription drug coverage. Low-income Medicare consumers who also qualify for Medicaid, a Medicare Savings Program, or Extra Help, are automatically enrolled into Medicare Part D.'
        ]
      },
      {
        Question: 'What medications are covered by Medicare?',
        Answer: [
          "<p>Each Medicare drug plan has its own list of drugs that are covered. This is called a formulary. Medicare Advantage and Part D formularies must include at least two drugs in the most commonly prescribed drug classes. However, your Medicare formulary might not include the specific drug you need. In this case, you should consider switching to another Medicare Part D plan during open enrollment.</p><p class='lastPara'>Some medications aren’t covered at all by Medicare Part D, such as certain brand-name drugs, weight-loss drugs, sexual dysfunction drugs, prescription vitamins, and more. In these cases, and at times when you cannot switch plans, SingleCare may be your cheapest option.</p>"
        ]
      }
    ]
  },
  es: {
    metaTitle: 'SingleCare y Medicare | SingleCare',
    metaDescription:
      'Descubre que SingleCare puede ser más barato que Medicare, y maximiza tus ahorros en medicamentos recetados.',
    medicareTopDrugsHeading: 'Los mejores precios disponibles:',
    ogTitle: 'SingleCare y Medicare',
    ogDescription:
      'Tus medicamentos pueden ser más baratos con SingleCare que con Medicare. Averigua cuándo (y cómo) usar SingleCare en lugar de Medicare para maximizar tus ahorros.',
    medicareTopDrugs: [
      {
        name: 'Amlodipine Besylate',
        seoName: 'amlodipine-besylate'
      },
      {
        name: 'Benzonatate',
        seoName: 'benzonatate'
      },
      {
        name: 'Cyclobenzaprine Hcl',
        seoName: 'cyclobenzaprine-hcl'
      },
      {
        name: 'Albuterol Sulfate Hfa',
        seoName: 'albuterol-sulfate-hfa'
      },
      {
        name: 'Cyanocobalamin',
        seoName: 'cyanocobalamin'
      },
      {
        name: 'Lisinopril',
        seoName: 'lisinopril'
      },
      {
        name: 'Hydrochlorothiazide',
        seoName: 'hydrochlorothiazide'
      },
      {
        name: 'Metoprolol Succinate Er',
        seoName: 'metoprolol-succinate-er'
      }
    ],
    relatedConditions: [
      {
        title: 'Blood Pressure',
        slug: 'blood-pressure-treatment-and-medications'
      },
      {
        title: 'high cholesterol',
        slug: 'high-cholesterol-treatment-and-medications'
      },
      {
        title: 'Arthritis',
        slug: 'arthritis-treatment-and-medications'
      },
      {
        title: 'Diabetes',
        slug: 'diabetes-treatment-and-medications'
      },
      {
        title: 'Congestive Heart Failure',
        slug: 'congestive-heart-failure-treatment-and-medications'
      },
      {
        title: 'Depression',
        slug: 'depression-treatment-and-medications'
      },
      {
        title: 'COPD',
        slug: 'copd-treatment-and-medications'
      },
      {
        title: 'Alzheimer’s',
        slug: 'alzheimers-treatment-and-medications'
      },
      {
        title: 'Atrial Fibrillation ',
        slug: 'atrial-fibrillation-treatment-and-medications'
      }
    ],
    medicareFaqs: [
      {
        Question: '¿Por qué debería considerar SingleCare si tengo Medicare?',
        Answer: [
          'Incluso con Medicare Advantage o Medicare Part D, los precios de los medicamentos de Medicare pueden seguir siendo elevados si no calificas para los subsidios de bajos ingresos como “Extra Help”. En algunos medicamentos recetados, puedes ahorrar más si usas una tarjeta de descuento gratuita para medicamentos de SingleCare en lugar de Medicare.'
        ]
      },
      {
        Question: '¿Puedes usar SingleCare con Medicare?',
        Answer: [
          'Cualquiera puede usar los cupones gratuitos  para medicamentos de SingleCare, incluso si recibes cobertura de medicamentos a través de Medicare Advantage o Medicare Part D. Pídele a un farmacéutico que compare lo que pagarías con SingleCare y Medicare para ver si puedes ahorrar en tus medicamentos. Sin embargo, ten en cuenta que SingleCare y Medicare no se pueden usar juntos; debes usar uno u otro.'
        ]
      },
      {
        Question: '¿Cuándo debería usar SingleCare en lugar de Medicare?',
        Answer: [
          "<p>SingleCare puede ayudar a los usuarios de Medicare a ahorrar en medicamentos cuando:</p><ul><li>No tienes cobertura de medicamentos a través de Medicare Advantage o Medicare Part D.</li><li>Los precios de SingleCare son más bajos que tu copago o coseguro de Medicare (compara los precios en singlecare.com o nuestra aplicación móvil antes de ir a la farmacia).</li><li>Tu medicamento no está cubierto por tu plan de Medicare Part D.</li><li>Estás en el “agujero de dona” de Medicare (también conocido como período sin cobertura).</li></ul><p class='lastPara'>Nota: si usas una tarjeta de descuento como SingleCare en lugar de Medicare, tus costos personales no se aplicarán a tu deducible de Medicare.</p>"
        ]
      },
      {
        Question: '¿Por qué Medicare no es siempre la opción más barata?',
        Answer: [
          'Medicare Advantage y Part D tienen diferentes niveles de cobertura. Los medicamentos del nivel 1 generalmente tienen el copago más bajo. Cuanto más alto sea el nivel, más pagarás de tu bolsillo. Entonces, incluso si tu medicamento está cubierto por tu plan de Medicare, tu descuento de SingleCare puede ser mayor que el de Medicare, a menos que califiques para el subsidio de bajos ingresos de Medicare Part D llamado “Extra Help”.'
        ]
      },
      {
        Question: '¿Qué partes de Medicare cubren las recetas médicas?',
        Answer: [
          'Medicare Part D cubre los medicamentos. Si tienes Medicare Part A o Part B, puedes inscribirte en una cobertura de medicamentos de Medicare por separado a través de la Medicare Part D. Medicare Advantage (también llamada Part C) puede combinar Medicare Part A, B y D. Los usuarios de Medicare de bajos ingresos que también califican para Medicaid, un Programa de Ahorros de Medicare, o “Extra Help” quedan inscritos automáticamente en Medicare Part D.'
        ]
      },
      {
        Question: '¿Qué medicamentos cubre Medicare?',
        Answer: [
          '<p>Cada plan de medicamentos de Medicare tiene su propia lista de medicamentos cubiertos. A esto se le llama formulario. Los formularios de Medicare Advantage y Part D deben incluir al menos dos medicamentos en las clases de medicamentos recetados con mayor frecuencia. Sin embargo, es posible que tu formulario de Medicare no incluya el medicamento específico que necesitas. En este caso, debes considerar cambiarte a otro plan de Medicare Part D durante la inscripción abierta.</p>' +
            "<p class='lastPara'>Algunos medicamentos no están cubiertos en absoluto por Medicare Part D, como ciertos medicamentos de marca, medicamentos para bajar de peso, medicamentos para la disfunción sexual, vitaminas recetadas y más. En estos casos, y cuando no puedas cambiar de plan, SingleCare puede ser tu opción más barata.</p>"
        ]
      }
    ]
  }
};

export const spanishResouceData = {
  name: 'Resources',
  headline: 'Recursos',
  introText:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin convallis, sem at efficitur varius, neque enim commodo lacus, et accumsan nunc risus in diam. In vulputate nibh magna, ut eleifend magna tristique nec. Mauris arcu velit, mollis vitae odio ac, viverra vulputate odio. Nullam ut efficitur lectus. Quisque mi dui, sagittis in mauris non, sollicitudin cursus leo. Mauris ac sagittis dui. Integer fermentum felis sed sapien molestie, sit amet commodo tortor porta. Maecenas quam risus, luctus in risus volutpat, aliquet interdum tortor. Nulla sed eros cursus, pretium arcu nec, commodo diam. Interdum et malesuada fames ac ante ipsum primis in faucibus.',
  featuredArticleHeader: 'Articulos recientes',
  featuredArticles: [
    {
      title: 'Title',
      medicalReviewer: 'Name',
      slug: 'title',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut finibus eros. Phasellus maximus tristique ultrices. Mauris id ipsum ut an',
      publishedAt: 'January 19, 2022',
      imageURL:
        'https://images.ctfassets.net/nyc8uiobrqzx/1vfeJWEZMe3bnawOdJnqq4/f9e40e119218ade2772dcf682c692e0a/Migraine.png'
    },
    {
      title: 'lorem ipsum',
      medicalReviewer: 'Anis Rehman',
      slug: 'lorem-ipsum',
      description: 'lorem ipsum',
      publishedAt: 'January 19, 2022',
      imageURL:
        'https://images.ctfassets.net/nyc8uiobrqzx/7uK74Miwm2wnH3V8ZBQ7t5/98a3572ccfa378881c7592a163c64cd7/Pink_eye.png'
    },
    {
      title: 'test',
      medicalReviewer: 'Kristi C. Torres',
      slug: 'test',
      description:
        'Las deudas médicas son un problema creciente en EE. UU., y muchos estadounidenses experimentan inestabilidad financiera e incluso la bancar',
      publishedAt: 'January 19, 2022',
      imageURL:
        'https://images.ctfassets.net/nyc8uiobrqzx/7h8LAbbdciQ2XzIrdD2Ll1/8455ab5a08b7e5adc5ea65ea5b818430/Anxiety.png'
    },
    {
      title: 'Title',
      medicalReviewer: 'Name',
      slug: 'title',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ut finibus eros. Phasellus maximus tristique ultrices. Mauris id ipsum ut an',
      publishedAt: 'January 19, 2022',
      imageURL:
        'https://images.ctfassets.net/nyc8uiobrqzx/1vfeJWEZMe3bnawOdJnqq4/f9e40e119218ade2772dcf682c692e0a/Migraine.png'
    }
  ],
  moreResourcesHeader: 'Mas recursos',
  additionalArticles: [
    {
      title: 'lorem ipsum',
      slug: 'lorem-ipsum'
    },
    {
      title: 'lorem ipsum',
      slug: 'lorem-ipsum'
    },
    {
      title: 'lorem ipsum',
      slug: 'lorem-ipsum'
    },
    {
      title: 'lorem ipsum',
      slug: 'lorem-ipsum'
    }
  ]
};
